export const Icon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#949494">
            <path d="M18.4,4.4L14,7L6,5L5,6l5.5,4.5L8,14H5l-1,1l2.5,1.5l1,1L9,20l1-1v-3l3.5-2.5L18,19l1-1l-2-8l2.6-4.4 c0.2-0.4,0.2-0.8-0.1-1.1S18.8,4.1,18.4,4.4z" />
        </svg>
    );
};
